import { QuestionCircleOutlined } from '@ant-design/icons'
import { Radio, RadioChangeEvent, Typography } from 'antd'
import React, { FunctionComponent, useCallback, useState } from 'react'

import { LoanCalculatorInput } from '../components/LoanCalculatorInput/LoanCalculatorInput'
import { LoanCalculatorOutput } from '../components/LoanCalculatorOutput/LoanCalculatorOutput'
import { PageLayout } from '../components/PageLayout/PageLayout'
import { LoanInput, LoanType } from '../utils/loanCalculatorHelpers'

const { Title } = Typography

export const LoanCalculator: FunctionComponent = () => {
  const [loanType, setLoanType] = useState<LoanType>(LoanType.Annuity)
  const [loanInput, setLoanInput] = useState<LoanInput>({
    amount: 1000000,
    months: 24,
    interestRate: 14.5,
  })

  const handleLoanTypeChange = useCallback((e: RadioChangeEvent) => {
    setLoanType(e.target.value as LoanType)
  }, [])

  const handleAmountChange = useCallback((value: number) => {
    setLoanInput(prev => ({ ...prev, amount: value }))
  }, [])

  const handleMonthsChange = useCallback((value: number) => {
    setLoanInput(prev => ({ ...prev, months: value }))
  }, [])

  const handleInterestRateChange = useCallback((value: number) => {
    setLoanInput(prev => ({ ...prev, interestRate: value }))
  }, [])

  return (
    <PageLayout title="Úvěrová kalkulačka" isContainer>
      <div className="p-6 max-w-5xl mx-auto">
        <Title level={4} className="mb-4">
          Typ splácení
        </Title>

        <div className="flex flex-wrap gap-4 mb-8">
          <Radio.Group
            value={loanType}
            onChange={handleLoanTypeChange}
            size="large"
          >
            <Radio.Button value={LoanType.Annuity}>Anuitní</Radio.Button>
            <Radio.Button value={LoanType.Balloon}>Balónové</Radio.Button>
          </Radio.Group>

          <div className="flex w-full md:flex-1 px-4 py-2 md:py-0 bg-gray-50 text-gray-400 rounded space-x-2 items-center">
            <QuestionCircleOutlined />
            <span>
              {loanType === LoanType.Annuity
                ? 'úvěr je splácen v pravidelných měsíčních splátkách po celou dobu úvěru ve stejné výši.'
                : 'každý měsíc se splácí pouze úroky. V posledním měsíci se kromě úroků splatí i celá jistina najednou.'}
            </span>
          </div>
        </div>

        <LoanCalculatorInput
          loanInput={loanInput}
          onAmountChange={handleAmountChange}
          onMonthsChange={handleMonthsChange}
          onInterestRateChange={handleInterestRateChange}
        />

        <LoanCalculatorOutput loanType={loanType} loanInput={loanInput} />
      </div>
    </PageLayout>
  )
}

export default LoanCalculator
